import React from 'react';
import { initialFilters } from '../../models/library';
import { useTranslation } from 'react-i18next';

function FilterSelect({ name, options, label, setState, state, disabled, ...props }) {
    const {t} = useTranslation();

    const cutString = (str) => {
        if (str.length > 30) {
            return str.slice(0, 30) + '...'
        } else {
            return str
        }

    }

    return (
        <div className={`flex flex-col box-border ${props.className}`}>
            <label className="font-bold my-2">{label}</label>
            <select
                className="rounded-lg p-2"
                disabled={disabled}
                value={state[name]}
                onChange={e => {
                    setState({ ...state, [name]: e.target.value})
                }}
            >
                <option value={''} key={'all'}>{t('libraryPage.filters.all')}</option>
                {name === 'subject'
                    ? options.sort(
                        (a, b) => {
                            let nameA = t(`libraryPage.filters.${name}.${a.value}`)
                            let nameB = t(`libraryPage.filters.${name}.${b.value}`)
                            return nameA.localeCompare(nameB);
                        }).map(option => {
                                return (
                                    <option value={option.value} key={option.value} className="text-wrap break-words overflow-ellipsis">{cutString(t(`libraryPage.filters.${name}.${option.value}`))}</option>
                                )
                            })
                        : options.map(option => {
                            return (
                                <option value={option.value} key={option.value}>{t(`libraryPage.filters.${name}.${option.value}`)}</option>
                            )
                })}
            </select>
        </div>
    );
}

export default FilterSelect;
